// Copyright (c) Microsoft Corporation. All rights reserved.

import "./../App.css"

// import { Button } from "react-bootstrap";

import logo from "../img/logo.png"
import MeetingProps from "../wego/hosts/WeGoHostedProps"
import React from "react"
import WegoConstants from "../wego/misc/WegoConstants"

interface SampleAppProps extends MeetingProps {}

type SampleAppState = {
  isShowingRemoteContent: boolean
  height: number
  width: number
}

const getSampleWindowWidth = () => window.innerWidth - 10
const getSampleWindowHeight = () => window.innerHeight - 80

// Sample app that is hosted in Teams. Contains dummy content demonstration.
class SampleApp extends React.Component<SampleAppProps, SampleAppState> {
  state: SampleAppState = {
    isShowingRemoteContent: false,
    width: getSampleWindowWidth(),
    height: getSampleWindowHeight(),
  }

  handleResize: () => void

  constructor(props: SampleAppProps) {
    super(props)
    this.handleResize = this.handleResizeCall.bind(this)
  }

  handleResizeCall() {
    this.setState({
      width: getSampleWindowWidth(),
      height: getSampleWindowHeight(),
    })
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
  }

  render() {
    const surface = this.props.surface
    const isInSidePanel = surface === WegoConstants.Surfaces.SidePanel

    return (
      <div className="App">
        {/* { // Demonstrates how content can be rendered differently based on surface canvas.
                    isInStage &&
                    <div className="centered-container">
                        <Button className="wego-column-button" onClick={() => this.setState(prevState => ({
                            isShowingRemoteContent: !prevState.isShowingRemoteContent
                        }))}>{this.state.isShowingRemoteContent ? "Show sample app" : "Show web content"}</Button>
                    </div>
                }

                <br /> */}

        {isInSidePanel ? (
          <div style={{ background: "white", height: "100%" }}>
            <img src={logo} alt="Spatial Logo" />
            <h2>Please cast to stage for the best experience </h2>
          </div>
        ) : (
          // <iframe
          //   src="http://localhost:3000/rooms/60d0d3835e4afb0001ca3af1"
          //   title="Spatial"
          //   allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
          //   sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
          //   allowFullScreen
          //   frameBorder="0"
          // />
          <iframe
            src="https://deploy-preview-6200--adoring-tesla-fc69b1.netlify.app/rooms/60d0d3835e4afb0001ca3af1"
            title="Spatial"
            allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
            sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
            allowFullScreen
            frameBorder="0"
          />
        )}

        {/* <iframe
          src="http://localhost:3000/rooms/60d0ce5c8736f60001688121"
          title="Spatial"
          allow="geolocation *; microphone *; camera *; midi *; encrypted-media *;"
          sandbox="allow-forms allow-modals allow-popups allow-pointer-lock allow-scripts allow-same-origin allow-downloads"
          allowFullScreen
          frameBorder="0"
        /> */}

        {/* <iframe
          src={"https://altvr.com/"}
          title={"AltspaceVR"}
          width={this.state.width}
          height={this.state.height}
        /> */}

        {/* The room ID is hard coded */}
        {/* <iframe src="http://localhost:3000/rooms/5fc7aa672f137725d1bb3492" title="Spatial" allow="camera *; microphone *" /> */}
      </div>
    )
  }
}

export default SampleApp
